import { useCallback, useContext, useState } from "react";
import useApi from "./useApi";
import useModal from "./useModal";
import { DownloadsContext } from "contexts";

const useExport = ({ api, reportType, mappedFilterState }) => {
  const { request } = useApi({ api, params: api.params });
  const { addPendingDownload } = useContext(DownloadsContext);
  const [loading, setLoading] = useState(false);
  const downloadProgressModal = useModal();

  const exportReport = useCallback(
    async ({ fileType } = {}) => {
      const filterState = {
        ...mappedFilterState,
        ...(fileType ? { fileType } : {}),
        connectionId: localStorage.getItem("connectionId"),
      };
      delete filterState.page;
      delete filterState.perPage;

      try {
        setLoading(true);
        const resp = await request({ ...filterState, reportType });
        setLoading(false);
        downloadProgressModal.show();
        addPendingDownload(resp?.fileName);
      } catch {
        setLoading(false);
      }
    },
    [request, reportType, mappedFilterState, addPendingDownload, downloadProgressModal],
  );

  return { exportReport, exporting: loading, downloadProgressModal };
};

export default useExport;
